module.exports = __webpack_public_path__ + "img/pride-and-prejudice.0de48800.png";